export { default } from './IOElement';
import { IIOElementProps as IIOElementPropsInt } from './IOElement';
export type IIOElementProps = IIOElementPropsInt;
